import { render, staticRenderFns } from "./MenuDivider.vue?vue&type=template&id=41589e68"
import script from "./MenuDivider.vue?vue&type=script&lang=js"
export * from "./MenuDivider.vue?vue&type=script&lang=js"
import style0 from "./MenuDivider.vue?vue&type=style&index=0&id=41589e68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports